export const isMp4 = (url?: string): boolean => !!url && /\.mp4(\?.*)?$/i.test(url);

export const withAutoplay = (url?: string): string | undefined => {
  if (!url) return url;
  if (/autoplay=/i.test(url)) return url;
  return url.includes('?') ? `${url}&autoplay=1` : `${url}?autoplay=1`;
};
